module.exports = __webpack_public_path__ + "media/images/list-style-image-01de054c2517c9344d55216ad19ca81d.png";